import { QueryClient } from "@tanstack/react-query";
import { DEFAULT_QUERY_CLIENT_CONFIG } from "../containers";
// import { Duration } from "luxon";

export const queryClient = new QueryClient(DEFAULT_QUERY_CLIENT_CONFIG);
